/* eslint-disable max-len */
import * as R from 'ramda';

export default function PolicyManagementSettingsDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  orgDataService,
  pmDataService
) {
  const vm = this;

  vm.isoUsers = [];
  vm.isoOptions = [];

  vm.isoPrimaryOptions = [];
  vm.isoSecondaryOptions = [];
  vm.isoTertiaryOptions = [];

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleExpandSectionClick = _handleExpandSectionClick;
  vm.handleFormSubmit = _handleFormSubmit;

  vm.handleOptionalCustomRadioChange = _handleOptionalCustomRadioChange;
  vm.handleCommitteeNameChange = _handleCommitteeNameChange;
  vm.handleOptionalPrimaryFederalRegulatorRadioChange = _handleOptionalPrimaryFederalRegulatorRadioChange;
  vm.handleISOResourceChange = _handleISOResourceChange;

  vm.getAutocompleteItemClass = _getAutocompleteItemClass;

  vm.hasSettings = (vm.settings !== undefined) && (vm.settings.customerConfiguration !== undefined);

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleExpandSectionClick(section, isExpanded) {
    if (!R.isNil(isExpanded)) {
      vm[`${section}IsExpanded`] = isExpanded;
    } else {
      vm[`${section}IsExpanded`] = !vm[`${section}IsExpanded`];
    }
  }

  function _handleOptionalCustomRadioChange(variableName) {
    if (vm[`${variableName}Radio`] !== '') {
      vm.variablesToSave[variableName] = vm[`${variableName}Radio`];
    }
  }

  function _handleOptionalPrimaryFederalRegulatorRadioChange() {
    if (vm.variablesToSave.primaryFederalRegulator === 'OCC') {
      vm.variablesToSave.incidentTimeReportingRequirement = '36 hours';
    } else if (vm.variablesToSave.primaryFederalRegulator === 'FRB') {
      vm.variablesToSave.incidentTimeReportingRequirement = '36 hours';
    } else if (vm.variablesToSave.primaryFederalRegulator === 'FDIC') {
      vm.variablesToSave.incidentTimeReportingRequirement = '36 hours';
    } else if (vm.variablesToSave.primaryFederalRegulator === 'NCUA') {
      vm.variablesToSave.incidentTimeReportingRequirement = '72 hours';
    }
  }

  function _handleCommitteeNameChange(evt) {
    const newITCommitteeName = vm.variablesToSave.itCommitteeName;

    if ((vm.primaryIsoResource !== undefined) && (vm.primaryIsoResource !== null) && (vm.primaryIsoResource.isVendor === false) 
      && (vm.primaryIsoResource.userId === -1)) {
        // Primary Resource is IT Steering Committee
        vm.primaryIsoResource.name = newITCommitteeName;
    }

    if ((vm.secondaryIsoResource !== undefined) && (vm.secondaryIsoResource !== null) && (vm.secondaryIsoResource.isVendor === false) 
      && (vm.secondaryIsoResource.userId === -1)) {
        // Secondary Resource is IT Steering Committee
        vm.secondaryIsoResource.name = newITCommitteeName;
    }

    if ((vm.tertiaryIsoResource !== undefined) && (vm.tertiaryIsoResource !== null) && (vm.tertiaryIsoResource.isVendor === false) 
      && (vm.tertiaryIsoResource.userId === -1)) {
        // Tertiary Resource is IT Steering Committee
        vm.tertiaryIsoResource.name = newITCommitteeName;
    }
  }

  function _handleISOResourceChange(acvm) {
    const item = acvm.selectedItem;
    const position = acvm.position;

    const isPrimaryResource = (vm.primaryIsoResource !== undefined) && (vm.primaryIsoResource !== null) && (item !== null)
      && (((vm.primaryIsoResource.isVendor === true) && (vm.primaryIsoResource.vendorId === item.vendorId))
        || ((vm.primaryIsoResource.isVendor === false) && (vm.primaryIsoResource.userId === item.userId)));

    const isSecondaryResource = (vm.secondaryIsoResource !== undefined) && (vm.secondaryIsoResource !== null) && (item !== null)
      && (((vm.secondaryIsoResource.isVendor === true) && (vm.secondaryIsoResource.vendorId === item.vendorId))
        || ((vm.secondaryIsoResource.isVendor === false) && (vm.secondaryIsoResource.userId === item.userId)));

    const isTertiaryResource = (vm.tertiaryIsoResource !== undefined) && (vm.tertiaryIsoResource !== null) && (item !== null)
      && (((vm.tertiaryIsoResource.isVendor === true) && (vm.tertiaryIsoResource.vendorId === item.vendorId))
        || ((vm.tertiaryIsoResource.isVendor === false) && (vm.tertiaryIsoResource.userId === item.userId)));

    if (position === 'primary') {
      if (isSecondaryResource) {
        alerts.error('The Primary ISO Resource cannot be the same as the Secondary ISO Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryResource) {
        alerts.error('The Primary ISO Resource cannot be the same as the Tertiary ISO Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'secondary') {
      if (isPrimaryResource) {
        alerts.error('The Secondary ISO Resource cannot be the same as the Primary ISO Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryResource) {
        alerts.error('The Secondary ISO Resource cannot be the same as the Tertiary ISO Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'tertiary') {
      if (isPrimaryResource) {
        alerts.error('The Tertiary ISO Resource cannot be the same as the Primary ISO Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isSecondaryResource) {
        alerts.error('The Tertiary ISO Resource cannot be the same as the Secondary ISO Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    }
  }

  function _handleFormSubmit() {
    if ($scope.editPolicyManagementSettingsForm.$invalid) {
      return Promise.resolve();
    }
    _transformResourcesToSave();
    vm.variables = _transformVariablesForSave(vm.variablesToSave, vm.variables);
    loaderService.showViewLoader = true;
    return pmDataService.saveVariables(vm.variables).then((variablesResponse) => {
      if (variablesResponse.data) {
        $rootScope.$broadcast('pmVariablesUpdated', variablesResponse.data);
        if (vm.hasSettings) {
          pmDataService.saveSettings(vm.settings).then((settingsResponse) => {
            if (settingsResponse.data) {
              alerts.success('The Policy Manager Settings have been saved successfully.');
              loaderService.showViewLoader = false;
              if (vm.saveType === 'saveAndClose') {
                _closeDialog();
              }
            } else {
              alerts.error('Error occurred while saving Policy Manager Settings.');
              loaderService.showViewLoader = false;
            }
          });
        } else {
          alerts.success('The Policy Manager Variables have been saved successfully.');
          loaderService.showViewLoader = false;
          if (vm.saveType === 'saveAndClose') {
            _closeDialog();
          }
        }
      } else {
        alerts.error('Error occurred while saving Policy Manager Variables.');
        loaderService.showViewLoader = false;
      }
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    
    // Users
    R.forEach((user) => {
      const isoOption = {
        isVendor: false,
        name: user.fullName,
        planPriority: null,
        userId: user.userId,
        vendorId: null,
      };
      if (isoOption.name === null) {
        isoOption.name = '<Unknown>';
      }
      vm.isoUsers.push(isoOption);
      vm.isoOptions.push(isoOption);
    }, vm.users);

    // Vendors
    R.forEach((vendor) => {
      const isoOption = {
        isVendor: true,
        name: vendor.name,
        planPriority: null,
        userId: null,
        vendorId: vendor.vendorId,
      };
      if (isoOption.name === null) {
        isoOption.name = '<Unknown>';
      }
      vm.isoOptions.push(isoOption);
    }, vm.vendors);

    // Add the committee to the list
    R.forEach((variable) => {
      if (variable.name === 'itCommitteeName') {
        const committeeOption = {
          isVendor: false,
          name: variable.value,
          planPriority: null,
          userId: -1,
          vendorId: null,
        };
        vm.isoUsers.push(committeeOption);
        vm.isoOptions.push(committeeOption);
      }
    }, vm.variables);

    vm.isoUsers = _sort(vm.isoUsers, 'name');
    vm.isoOptions = _sort(vm.isoOptions, 'name');

    vm.isoPrimaryOptions = vm.isoUsers;
    vm.isoSecondaryOptions = vm.isoOptions;
    vm.isoTertiaryOptions = vm.isoOptions;

    _initVariables();
  }
/*
  function _refreshISOOptionsLists(clear) {
    // Set Primary ISO Options
    vm.isoPrimaryOptions = [];
    R.forEach((user) => {
      const isSecondResource = (vm.secondaryIsoResource !== undefined) && (vm.secondaryIsoResource !== null)
        && (((vm.secondaryIsoResource.isVendor === true) && (vm.secondaryIsoResource.vendorId === user.vendorId))
         || ((vm.secondaryIsoResource.isVendor === false) && (vm.secondaryIsoResource.userId === user.userId)));

      const isTertiaryResource = (vm.tertiaryIsoResource !== undefined) && (vm.tertiaryIsoResource !== null)
        && (((vm.tertiaryIsoResource.isVendor === true) && (vm.tertiaryIsoResource.vendorId === user.vendorId))
          || ((vm.tertiaryIsoResource.isVendor === false) && (vm.tertiaryIsoResource.userId === user.userId)));

      if ((!isSecondResource) && (!isTertiaryResource)) {
        vm.isoPrimaryOptions.push(user);
      }
    }, vm.isoUsers);

    // Set Secondary ISO Options
    vm.isoSecondaryOptions = [];
    R.forEach((option) => {
      const isPrimaryResource = (vm.primaryIsoResource !== undefined) && (vm.primaryIsoResource !== null)
        && (((vm.primaryIsoResource.isVendor === true) && (vm.primaryIsoResource.vendorId === option.vendorId))
          || ((vm.primaryIsoResource.isVendor === false) && (vm.primaryIsoResource.userId === option.userId)));

      const isTertiaryResource = (vm.tertiaryIsoResource !== undefined) && (vm.tertiaryIsoResource !== null)
        && (((vm.tertiaryIsoResource.isVendor === true) && (vm.tertiaryIsoResource.vendorId === option.vendorId))
          || ((vm.tertiaryIsoResource.isVendor === false) && (vm.tertiaryIsoResource.userId === option.userId)));

      if ((!isPrimaryResource) && (!isTertiaryResource)) {
        vm.isoSecondaryOptions.push(option);
      }
    }, vm.isoOptions);

    // Set Tertiary ISO Options
    vm.isoTertiaryOptions = [];
    R.forEach((option) => {
      const isPrimaryResource = (vm.primaryIsoResource !== undefined) && (vm.primaryIsoResource !== null)
        && (((vm.primaryIsoResource.isVendor === true) && (vm.primaryIsoResource.vendorId === option.vendorId))
          || ((vm.primaryIsoResource.isVendor === false) && (vm.primaryIsoResource.userId === option.userId)));

      const isSecondaryResource = (vm.secondaryIsoResource !== undefined) && (vm.secondaryIsoResource !== null)
        && (((vm.secondaryIsoResource.isVendor === true) && (vm.secondaryIsoResource.vendorId === option.vendorId))
          || ((vm.secondaryIsoResource.isVendor === false) && (vm.secondaryIsoResource.userId === option.userId)));

      if ((!isPrimaryResource) && (!isSecondaryResource)) {
        vm.isoTertiaryOptions.push(option);
      }
    }, vm.isoOptions);
    if (clear) {
      vm.isoTertiaryOptions = [];
    }
  }
*/
  function _sort(collection, key) {
    return collection.sort((a, b) => {
      const aValue = _getSortableValue(a, key);
      const bValue = _getSortableValue(b, key);
      if (aValue < bValue) return -1;
      if (aValue > bValue) return 1;
      return 0;
    });
  }

  function _getSortableValue(obj, key) {
    return typeof obj[key] === 'string' ? obj[key].toLowerCase() : obj[key];
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.settingsDialog);
  }

  function _initVariables() {
    vm.variablesToSave = {};
    R.forEach(
      (variable) => {
        vm.variablesToSave[variable.name] = (
          variable.name === 'corePasswordExpiration' || variable.name === 'networkPasswordExpiration'
        ) ? parseInt(variable.value, 10) : variable.value;

        _retrieveResourcesToDisplay(variable);

        if (variable.name === 'institutionType') {
          vm.institutionTypeRadio = (
            variable.value !== 'customer'
            && variable.value !== 'member'
          )
            ? ''
            : variable.value;
        }

        if (variable.name === 'websiteType') {
          vm.websiteTypeRadio = (
            variable.value !== 'Informational'
            && variable.value !== 'Transactional'
            && variable.value !== 'Informational and Transactional'
          )
            ? ''
            : variable.value;
        }

        if (variable.name === 'coreProviderName') {
          vm.coreProviderNameRadio = (
            variable.value !== 'CSI'
            && variable.value !== 'D+H'
            && variable.value !== 'Fidelity'
            && variable.value !== 'Fiserv'
            && variable.value !== 'IBT'
            && variable.value !== 'Jack Henry'
            && variable.value !== 'Modern Banking'
            && variable.value !== 'Navanta'
          )
            ? ''
            : variable.value;
        }

        if (variable.name === 'eBankingProviderName') {
          vm.eBankingProviderNameRadio = (
            variable.value !== 'CSI'
            && variable.value !== 'D+H'
            && variable.value !== 'Fidelity'
            && variable.value !== 'Fiserv'
            && variable.value !== 'IBT'
            && variable.value !== 'Jack Henry'
            && variable.value !== 'Modern Banking'
          )
            ? ''
            : variable.value;
        }

        if (variable.name === 'itCommitteeType') {
          vm.itCommitteeTypeRadio = (
            variable.value !== 'Board'
            && variable.value !== 'Management'
          )
            ? ''
            : variable.value;
        }

        if (variable.name === 'minimumItCommitteeMeetingFrequency') {
          vm.minimumItCommitteeMeetingFrequencyRadio = (
            variable.value !== 'Quarterly'
            && variable.value !== 'Semi-Annually'
            && variable.value !== 'Annually'
          )
            ? ''
            : variable.value;
        }

        if (variable.name === 'complianceReviewType') {
          vm.complianceReviewTypeRadio = (
            variable.value !== 'In-House Internal Audit'
            && variable.value !== 'Outsourced Internal Audit'
            && variable.value !== 'Internal Plus External Audit'
          )
            ? ''
            : variable.value;
        }

        if (variable.name === 'internalResources') {
          vm.internalResourcesRadio = (
            variable.value !== 'associate'
            && variable.value !== 'colleague'
            && variable.value !== 'employee'
            && variable.value !== 'end user'
            && variable.value !== 'partner'
            && variable.value !== 'team member'
          )
            ? ''
            : variable.value;
        }
      }, vm.variables
    );
    console.log(vm.variablesToSave);
  }

  function _transformVariablesForSave(variablesToSave, originalVariables) {
    return R.map(variable => R.merge(variable, {
      value: variablesToSave[variable.name],
    }), originalVariables);
  }

  function _transformResourcesToSave() {
    if (vm.primaryIsoResource) {
      vm.variablesToSave.primaryIsoResource = vm.primaryIsoResource.name;
    } else {
      vm.variablesToSave.primaryIsoResource = null;
    }

    if (vm.secondaryIsoResource) {
      vm.variablesToSave.secondaryIsoResource = vm.secondaryIsoResource.name;
    } else {
      vm.variablesToSave.secondaryIsoResource = null;
    }

    if (vm.tertiaryIsoResource) {
      vm.variablesToSave.tertiaryIsoResource = vm.tertiaryIsoResource.name;
    } else {
      vm.variablesToSave.tertiaryIsoResource = null;
    }
  }

  function _retrieveResourcesToDisplay(variable) {
    if (vm.isoOptions && vm.isoOptions.length > 0) {
      if (variable.name === 'primaryIsoResource') {
        if (variable.value !== null) {
          const findPrimary = R.filter(R.propEq('name', variable.value), vm.isoOptions);
          if (findPrimary) {
            vm.primaryIsoResource = findPrimary[0];
          }
        }
      }
      if (variable.name === 'secondaryIsoResource') {
        if (variable.value !== null) {
          const findSecondary = R.filter(R.propEq('name', variable.value), vm.isoOptions);
          if (findSecondary) {
            vm.secondaryIsoResource = findSecondary[0];
          }
        }
      }
      if (variable.name === 'tertiaryIsoResource') {
        if (variable.value !== null) {
          const findTertiary = R.filter(R.propEq('name', variable.value), vm.isoOptions);
          if (findTertiary) {
            vm.tertiaryIsoResource = findTertiary[0];
          }
        }
      }
    }
  }

  function _getAutocompleteItemClass(item) {
    if (!item) {
      return '';
    }
    return item.isVendor ? 'vendor' : 'person';
  }
}

PolicyManagementSettingsDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'orgDataService',
  'pmDataService',
];
